/**
 * Cores das seções da landing, alinhadas à identidade da marca-mãe Codout (codout.com):
 * tinta #0b1520 sobre claro, accent ciano-azul, superfícies escuras em #0b1520. As cores
 * SEMÂNTICAS de estado (roxo=Suggest, âmbar=AutoReply, verde=live/leitura, vermelho=destrutivo)
 * permanecem — fazem parte da linguagem do produto. O accent de marca (`brandAccent`, `eyebrow`,
 * `brandMark`) usa o ciano Codout; os CTAs de ênfase usam a tinta (`ink`), como no codout.com.
 */
export const lightPalette = {
  // Accent de marca Codout (ciano-azul) — usado em links/destaques sobre claro.
  brandAccent: '#126a87',
  slate: '#5c6a78', // rótulos/eyebrows em mono (mesmo slate do codout.com)
  ink: '#0b1520',
  textStrong: 'oklch(38% 0 0)',
  textBody: 'oklch(45% 0 0)',
  textMuted: 'oklch(52% 0 0)',
  textFaint: 'oklch(55% 0 0)',
  textSubtle: 'oklch(58% 0 0)',
  borderDefault: 'oklch(91% 0 0)',
  borderSoft: 'oklch(93% 0 0)',
  borderSofter: 'oklch(93.5% 0 0)',
  borderStrong: 'oklch(84% 0 0)',
  surface: '#fff',
  surfaceSubtle: 'oklch(98.5% 0 0)',
  successBg: 'oklch(60% 0.13 155 / 0.12)',
  successFg: 'oklch(42% 0.13 155)',
  warningBg: 'oklch(72% 0.14 80 / 0.18)',
  warningFg: 'oklch(50% 0.13 80)',
  dangerBg: 'oklch(56% 0.19 25 / 0.1)',
  dangerFg: 'oklch(48% 0.19 25)',
  dangerRowBg: 'oklch(56% 0.19 25 / 0.05)',
  purple: 'oklch(56% 0.17 300)',
  purpleFg: 'oklch(46% 0.17 300)',
  purpleBorder: 'oklch(56% 0.17 300 / 0.3)',
  purpleBg: 'oklch(56% 0.17 300 / 0.05)',
} as const

export const darkPalette = {
  bg: '#0b1520',
  cardBg: '#111c29',
  fg: 'oklch(96% 0 0)',
  fgAlt: 'oklch(97% 0 0)',
  fgSoft: 'oklch(78% 0 0)',
  fgSofter: 'oklch(76% 0 0)',
  fgMuted: 'oklch(80% 0 0)',
  border: 'oklch(100% 0 0 / 0.1)',
  borderCard: 'oklch(100% 0 0 / 0.12)',
  eyebrow: '#5fc8f0',
  levelObserveBg: 'oklch(100% 0 0 / 0.08)',
  levelObserveFg: 'oklch(84% 0 0)',
  levelSuggestBorder: 'oklch(72% 0.14 300 / 0.5)',
  levelSuggestBg: 'oklch(72% 0.14 300 / 0.09)',
  levelSuggestBadgeBg: 'oklch(72% 0.14 300 / 0.2)',
  levelSuggestBadgeFg: 'oklch(88% 0.08 300)',
  levelSuggestDesc: 'oklch(82% 0 0)',
  levelAutoBorder: 'oklch(76% 0.13 80 / 0.4)',
  levelAutoBg: 'oklch(76% 0.13 80 / 0.07)',
  levelAutoBadgeBg: 'oklch(76% 0.13 80 / 0.18)',
  levelAutoBadgeFg: 'oklch(88% 0.09 80)',
  levelAutoDesc: 'oklch(80% 0 0)',
  ctaBg: 'oklch(97% 0 0)',
  ctaFg: 'oklch(17% 0 0)',
  ctaShadow: '0 14px 36px oklch(0% 0 0 / 0.4)',
  ctaSecBorder: 'oklch(100% 0 0 / 0.22)',
  ctaSecFg: 'oklch(94% 0 0)',
  ctaSubtitle: 'oklch(80% 0 0)',
} as const

export const footerPalette = {
  bg: '#0b1520',
  fg: 'oklch(80% 0 0)',
  muted: 'oklch(66% 0 0)',
  brandMark: '#5fc8f0',
  brandMarkFg: '#0b1520',
} as const
